import { t } from "ttag";

export const Disclaimer = () => (
  <footer className="flex flex-col gap-2.5 pt-6 text-center text-xs text-neutral-800">
    <p className="font-semibold">{t`DISCLAIMER & SAFETY INFORMATION`}</p>

    <p>
      {t`By selecting a program option, above, you agree that your card will be charged the amount presented to you on 
the checkout page as a result of your transaction today. You understand that the decision to issue a prescription (in 
any form) is a clinical determination made by your provider. If the provider determines a different medication or 
administration is appropriate, you will be charged or refunded the difference in price, based on the medication 
actually prescribed. If your provider determines that you are not eligible for the program, you will be refunded in 
full, as detailed in our Terms of Service.`}
    </p>

    <p>
      {t`Weight loss outcomes vary based on individual factors including starting weight, metabolic health, lifestyle, and adherence to the prescribed program. Testimonials and reviews reflect individual experiences and are not guarantees of specific outcomes. `}
    </p>

    <p className="py-2.5">
      {t`Medication eligibility and prescriptions are determined solely by licensed medical providers based on clinical 
appropriateness. Not all individuals will qualify for medication-based treatment. Always consult a licensed healthcare professional before beginning any weight loss or wellness program.`}
    </p>

    <p>
      {t`GLP-1 receptor agonists may cause serious side effects, including gastrointestinal symptoms and, in rare cases, 
thyroid C-cell tumors. Do not use GLP-1 medications if you or your family have a history of medullary thyroid 
carcinoma (MTC) or Multiple Endocrine Neoplasia syndrome type 2 (MEN 2). Patients should be monitored for symptoms such as persistent nausea, vomiting, abdominal pain, or changes in thyroid function.`}
    </p>

    <p className="py-2.5">
      {t`The LevelsRx program may include access to both FDA-approved branded medications and compounded drug 
products, based on what your licensed clinician determines is medically necessary. Compounded medications are not FDA-approved, and the FDA does not evaluate them for safety, effectiveness, or quality prior to use.`}
    </p>

    <p className="py-2.5">
      {t`LevelsRx is a technology platform that facilitates access to independent third-party healthcare providers and 
pharmacies. LevelsRx itself does not provide medical care, make treatment decisions, or dispense medications. All clinical decisions are made by licensed providers in accordance with applicable laws and standards of care. `}
    </p>

    <p>
      {t`LevelsRx does not manufacture compounded medications. Actual product appearance and labeling of the medication you receive will differ from website images.`}
    </p>
  </footer>
);
